// extracted by mini-css-extract-plugin
export default {"root":"TreeSelectBranchInput_root__4VMXU","select":"TreeSelectBranchInput_select__+oGRc","addButton":"TreeSelectBranchInput_addButton__8wZI9"};